module.exports = __webpack_public_path__ + "static/media/house-banner.105689f0.png";